<template>
  <div class="member__coupon__list">
    <div v-for="(item,index) in coupons" v-bind:key="index" class="member__coupon__list-item">
      <div class="member__coupon__list-item-tip"><img
          src="../../../assets/img/member/member_coupon_i.png">{{ item.useType === 1 ? "指定商品可用" : "全店通用" }}
      </div>
      <div class="member__coupon__list-item-name">VIP{{ item.saleType === 1 ? "代金券" : "折扣券" }}</div>
      <div class="member__coupon__list-item-detail">
        <div v-if="item && item.couponGoods  && item.couponGoods.length" class="member__coupon__list-item-detail-group">
          <div v-for="(couponGood,gindex) in item.couponGoods" v-bind:key="gindex"
               class="member__coupon__list-item-detail-group-goods" @click="goGoodsDetail(couponGood.goods_id)">
            <img :src="couponGood.original_img">
            <p>￥{{ couponGood.shop_price }}</p>
          </div>
        </div>
        <img v-if="item && item.useType === 0" class="member__coupon__list-item-detail-all"
             src="../../../assets/img/member/member_coupon_all_use.png">
        <div class="member__coupon__list-item-detail-rule">
          <p v-if="item.saleType===1" class="price"><span>￥</span>{{ item.money }}</p>
          <p v-else class="price">{{ getDisCount(item.discount) }}折</p>
          <p v-if="item.condition" class="limit">满{{ item.condition }}可用</p>
          <button :class='item.recived?"":"recived"'
                  :mg-stat-custom="`cont=${item.receiveStatus?'点击优惠券':'立即领取'}&label=btn&direct=cntp${item.receiveStatus===1?(item.useType==0?'&addr=/home':'&addr=/coupon/goods'):''}`"
                  :mg-stat-lob="`${item.receiveStatus===0?'couponid='+item.id:''}`" mg-stat-click
                  mg-stat-mod="coupon"
                  @click="getCoupon(index)"
          >{{ item.receiveStatus === 0 ? "立即领取" : "去使用" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCouponById } from 'apis/coupon';

export default {
  props: {
    coupons: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  watch: {
    coupons(val) {
      if (val && val.length > 0) {
        val = val.sort((a, b) => b.useType - a.useType);
      }
    },
  },
  methods: {
    goGoodsDetail(id) {
      this.$router.push({ path: '/goods/detail', query: { id, showBack: 1 } });
    },
    getDisCount(discount) {
      // 80 显示 8折  82 显示82折
      return discount % 10 ? discount : discount / 10;
    },
    async getCoupon(index) {
      try {
        const { receiveStatus, id, useType } = this.coupons[index];
        if (receiveStatus === 0) {
          await getCouponById({ couponId: id });
          this.coupons[index].receiveStatus = 1;
          this.$toast('已经领取咯，快去使用吧');
        } else if (useType) {
          this.$router.push({ path: '/coupon/goods', query: { id, showBack: 1 } });
        } else { // 全场通用跳首页
          this.$router.push({ path: '/home' });
        }
      } catch (e) {
        this.$toast(`${e.message}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.member {
  &__coupon {
    &__list {
      &-item {
        width: 702px;
        height: 270px;
        margin-top: 20px;
        background: url("../../../assets/img/member/member_coupon_rights_1.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        box-shadow: 0px 0px 16px -2px rgba(0, 0, 0, 0.1);
        border-radius: 10px;

        &-detail {
          width: 100%;

          &-rule {
            text-align: center;
            height: 125px;
            width: 200px;
            font-size: 24px;
            position: absolute;
            right: 0px;
            top: 48px;

            .price {
              span {
                font-size: 18px;
                font-weight: 400;
              }

              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: bold;
              height: 67px;
              line-height: 67px;
            }

            .limit {
              color: rgba(186, 133, 69, 1);
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
            }

            button {
              margin-top: 24px;
              color: #000;
              background-color: rgb(241, 181, 128);
              height: 48px;
              width: 140px;
              line-height: 50px;
              font-size: 24px;
              border-radius: 24px;
            }

            button.recived {
              color: rgb(241, 181, 128);
              background-color: #fff;
            }
          }

          &-group {
            text-align: center;
            height: 150px;
            padding-left: 30px;

            &-goods {
              margin-top: 70px;
              float: left;
              text-align: center;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              margin-right: 10px;
              width: 140px;

              img {
                width: 140px;
                height: 140px;
                border-radius: 10px;
                background-color: #0ba4da;
                box-shadow: 0px 0px 16px -2px rgba(0, 0, 0, 0.1);
              }
            }
          }

          &-all {
            width: 448px;
            height: 136px;
            margin-left: 30px;
            margin-top: 87px;
          }
        }

        &-tip {
          position: absolute;
          left: 23px;
          top: 24px;
          line-height: 40px;
          color: rgba(186, 133, 69, 1);
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          border-top-left-radius: 10px;
          text-align: center;

          img {
            height: 19px;
            width: 19px;
            margin-right: 8px;
          }
        }

        &-name {
          position: absolute;
          right: 22px;
          top: 1px;
          width: 150px;
          height: 40px;
          color: rgba(252, 244, 235, 1);
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          text-align: center;
        }

        &-btn {
          width: 60px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 0;
          color: #fff;
          background-color: grey;
          text-align: center;
          font-size: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          border-bottom-right-radius: 10px;
          border-top-right-radius: 10px;
        }
      }
    }
  }
}
</style>
